// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"meat-pepper"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2.36683 15.3995C2.36683 11.3997 7.37405 1.01773 12.6999 3.04998C15.4997 3.9999 15.9996 6.44428 15.9997 7.99966C17.5551 7.99981 19.8486 9.17351 20.9494 11.2994C23.5704 16.3615 12.3668 21.3999 8.36684 21.3999C6.15247 21.5302 5.14575 20.2899 4.95118 18.8154C3.47664 18.6208 2.23658 17.6138 2.36683 15.3995Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15.9997 9.64955V7.99966M15.9997 7.99966C15.9996 6.44428 15.4997 3.9999 12.6999 3.04998C7.37405 1.01773 2.36683 11.3997 2.36683 15.3995C2.23658 17.6138 3.47664 18.6208 4.95118 18.8154C5.14575 20.2899 6.15247 21.5302 8.36684 21.3999C12.3668 21.3999 23.5704 16.3615 20.9494 11.2994C19.8486 9.17351 17.5551 7.99981 15.9997 7.99966ZM16.4498 7.30801C17.1606 6.40682 18.4252 5.39353 19.9997 4.99979","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-meat-pepper')
export default class MeatPepperIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'meat-pepper',
    }
  }
}
